import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiFetch } from "@/lib/api";

const NavCtx = createContext(null);

export function NavigationProvider({ children }) {
  const [config, setConfig] = useState({});
  const [ctx, setCtx] = useState({ role: null, permissions: [], isAdmin: false });
  const [ready, setReady] = useState(false);

  const load = useCallback(async () => {
    try {
      const d = await apiFetch("/navigation");
      setConfig(d.config || {});
      setCtx({ role: d.role, permissions: d.permissions || [], isAdmin: !!d.is_admin, me: d.me || null });
    } catch { /* defaults */ } finally { setReady(true); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const save = useCallback(async (next) => {
    setConfig(next);
    await apiFetch("/navigation", { method: "PUT", body: JSON.stringify({ config: next }) });
  }, []);

  return <NavCtx.Provider value={{ config, ctx, ready, save, reload: load, setConfig }}>{children}</NavCtx.Provider>;
}

export const useNavigation = () => useContext(NavCtx);
